var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1330_1818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.96 13.4a6.425 6.425 0 0 0 6.424-6.425c0-3.546-2.877-6.403-6.424-6.403-3.546 0-6.423 2.876-6.423 6.404 0 3.527 2.877 6.423 6.423 6.423zm0-11.154a4.743 4.743 0 0 1 4.73 4.73 4.743 4.743 0 0 1-4.73 4.728 4.743 4.743 0 0 1-4.729-4.729 4.743 4.743 0 0 1 4.73-4.729zM.847 23.429h22.306A.841.841 0 0 0 24 22.58c0-4.433-3.606-8.059-8.06-8.059H8.06c-4.434 0-8.06 3.606-8.06 8.06 0 .472.374.847.847.847zm7.212-7.212h7.882a6.36 6.36 0 0 1 6.305 5.517H1.754c.413-3.094 3.074-5.517 6.305-5.517z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1330_1818"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgProfile;